import StateListenerRegistry from '../../../../react/features/base/redux/StateListenerRegistry';
import debounce from 'lodash/debounce';
import { analyticsEvents } from '../../../components/noise-suppression/constants';
import {
    sendAudioAnalytics
} from '../../../components/noise-suppression/functions';

/**
 * Listens for changes in the userSelectedMicDeviceLabel state to send analytics.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/base/settings'].userSelectedMicDeviceLabel,
    /* listener */ debounce((label, { dispatch, getState }, prevState) => {
        if (typeof prevState !== 'undefined') {
            const state = getState();

            sendAudioAnalytics({ dispatch,
                state,
                title: analyticsEvents.DEVICE_CHANGED_MANUALLY });
        }
    }, 2000)
);
